import { ConfigsListNode } from '@/types'

export default {
  parseConfigs(
    configsData: any,
    configsListNodeMap: Object,
    idCounter: number
  ): Object {
    //console.log(JSON.stringify(configsData))
    let configsObject: ConfigsListNode = {
      id: 1,
      name: '/',
      type: 'configs',
      globalType: 'rootNode',
      children: [],
      parentNodeId: 0,
      rootNodeId: 1,
      iconType: '',
      iconColor: '',
      versionsInfo: [],
    }

    //console.log(configsObject)
    for (const [key, value] of Object.entries(configsData)) {
      //loop over configurations - create new Config object and add it to children of the configs
      let configObject: ConfigsListNode = {
        id: ++idCounter,
        name: key,
        type: 'config',
        globalType: 'configNode',
        children: [],
        parentNodeId: 1,
        rootNodeId: idCounter, //for the root nodes, rootNodeId = itself
        iconType: 'sequence',
        iconColor: 'red',
        versionsInfo: [],
      }

      idCounter = this.buildRecursiveConfigObject(
        configObject,
        value,
        configObject.id,
        configsListNodeMap,
        idCounter
      )

      configsListNodeMap[configObject['id']] = configObject
      configsObject['children'].push(configObject)
    }
    configsListNodeMap[1] = configsObject
    /*     configsListNodeMap[1] = Object.assign(
      configsListNodeMap[1],
      configsObject
    ) */
    //console.log('MAP1: ' + JSON.stringify(configsListNodeMap))

    return { idCounter: idCounter }
  },

  buildRecursiveConfigObject(
    configObject: ConfigsListNode,
    body: any,
    parentID: number,
    configsListNodeMap: Object,
    idCounter: number
  ): number {
    
    interface ConfigInfo {
      name: string,
      created: string,
      release: string,
      creator: string
    }  
    //horriably naughty as it may be a map instead (the second part of the else statement)
    for (const [key, value] of Object.entries<ConfigInfo>(Object(body))) {
           
      var searchPattern = new RegExp(/^V[0-9]+$/) //version has to start with VXX where XX is the number
      if (searchPattern.test(key)) {
        //console.log('VERSION NUMBER:' + key)
        configObject.versionsInfo.push({ version: key, path: value["name"],
                                          created : value["created"],
                                          release: value["release"],
                                          creator: value["creator"]
                                       })        
        //console.log('VERSION: ' + JSON.stringify(configObject.versionsInfo))
      } else {
        //console.log('OBJECT CREATION')
        let configListSubNode: ConfigsListNode = {} as ConfigsListNode //might or might not be used
        configListSubNode.id = ++idCounter
        //console.log('ID: ' + idCounter)
        configListSubNode.name = key as string //no name
        configListSubNode.type == 'config'
        configListSubNode.globalType = 'configSubNode'
        configListSubNode.children = []
        configListSubNode.parentNodeId = parentID
        configListSubNode.rootNodeId = -1
        configListSubNode.iconType = ''
        configListSubNode.iconColor = ''
        configListSubNode.versionsInfo = []

        idCounter = this.buildRecursiveConfigObject(
          configListSubNode,
          value,
          configListSubNode['id'],
          configsListNodeMap,
          idCounter
        )
        configObject['children'].push(configListSubNode)
        configsListNodeMap[configListSubNode['id']] = configListSubNode
      }
    }

    return idCounter
  },
}
